const queries = {
  salaryDeductionApplications: () => ['salary-deduction-applications'],
  salaryDeductionApplication: (id: number) => ['salary-deduction-applications', id],
  salaryDeductionPolicyHistory: (costObjectId: number) => [
    'salary-deduction-applications',
    'policy-history',
    costObjectId,
  ],
}

export default queries
